import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { PARTNER_STATUS_VALUES } from '../../utils/partnerStatus';

const ActionIconButton = styled(IconButton)(({ theme, bordercolor, iconcolor }) => ({
  width: 36,
  height: 36,
  borderRadius: 8,
  border: `1px solid ${bordercolor ?? theme.palette.divider}`,
  color: iconcolor ?? theme.palette.text.secondary,
  backgroundColor: theme.palette.background.paper,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&.Mui-disabled': {
    opacity: 0.5,
  },
}));

const PartnerPendingStatusActions = ({ partnerName, disabled, onStatusChange }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
    <ActionIconButton
      bordercolor="#86efac"
      iconcolor="#16a34a"
      aria-label={`Accept ${partnerName}`}
      disabled={disabled}
      onClick={() => onStatusChange(PARTNER_STATUS_VALUES.LIVE)}
    >
      <CheckOutlinedIcon sx={{ fontSize: 18 }} />
    </ActionIconButton>
    <ActionIconButton
      bordercolor="#fca5a5"
      iconcolor="#dc2626"
      aria-label={`Reject ${partnerName}`}
      disabled={disabled}
      onClick={() => onStatusChange(PARTNER_STATUS_VALUES.REJECTED)}
    >
      <CloseOutlinedIcon sx={{ fontSize: 18 }} />
    </ActionIconButton>
  </Box>
);

export default PartnerPendingStatusActions;
